<template>
  <w-icon-wrapper
    :height='18'
    :width='18'
    icon-name='work-checkbox-indeterminate-icon'
    view-box='0 0 18 18'
  >
    <g
      id="Checkbox_Normal"
      transform="translate(-1134 -463)"
    >
      <g
        id="Rechteck_4031"
        data-name="Rechteck 4031"
        transform="translate(1134 463)"
        fill="none"
        stroke='currentColor'
        stroke-width="1"
      >
        <rect
          width="18"
          height="18"
          rx="3"
          stroke="none"
        />
        <rect
          x="0.5"
          y="0.5"
          width="17"
          height="17"
          rx="2.5"
          fill="none"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckboxIndeterminate' };
</script>
